module.exports = __webpack_public_path__ + "static/media/icon-water-heating.746ec1e2.svg";